module.exports = __webpack_public_path__ + "static/media/medium_full.30704e7ef776bc6c4975471f245f1868.svg";